import API from './index';

const api = {
    getSearchList(data) {
        return API.authAPI({
            url: '/application/get-applicationOrPostApproval-list',
            method: 'POST',
            data,
        });
    },
};

export default api;
